/* eslint-disable max-len */
import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { createContext, useContext } from 'react';
import { dates } from './dates';

export const CriticalErrorContext = createContext<FetchBaseQueryError | SerializedError | undefined>(undefined);
export const useCriticalErrorContext = (): FetchBaseQueryError | SerializedError | undefined => useContext(CriticalErrorContext);

export const ImpersonationContext = createContext<{ isApplicant: boolean, isImpersonator: boolean, canViewedUserBeImpersonated: boolean }>({
  isApplicant: false,
  isImpersonator: false,
  canViewedUserBeImpersonated: false,
});
export const useImpersonationContext = (): { isApplicant: boolean, isImpersonator: boolean, canViewedUserBeImpersonated: boolean } => useContext(ImpersonationContext);

export const PhaseContext = createContext<number>(0);
export const usePhaseContext = (): number => useContext(PhaseContext);

// eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
export const HelpContext = createContext<(obj: IModalObject) => void>((_: IModalObject) => { });
export const useHelpContext = (): (arg0: IModalObject) => void => useContext(HelpContext);

export const DatesContext = createContext<(lang: string) => IDates>((lang: string) => dates(lang));
export const useDatesContext = (): (arg0: string) => IDates => useContext(DatesContext);

export const ApplicantContext = createContext<IApplicant | undefined>(undefined);
export const useApplicantContext = (): IApplicant | undefined => useContext(ApplicantContext);

export const ApplicationsContext = createContext<IApplication[]>([]);
export const useApplicationsContext = (): IApplication[] => useContext(ApplicationsContext);

export const DateContext = createContext<Date>(new Date());
export const useDateContext = (): Date => useContext(DateContext);

export const SourceContext = createContext<ISourceType>('Azure AD');
export const useSourceContext = (): ISourceType => useContext(SourceContext);
